import { fetchNewobjectsBuilder } from './fetchNewobjectsBuilder';
import { IApplicationContext } from '../../types/applicationContext';
import { IOffersData } from '../../types/offersData';
import { ISimilarNewobjectFromDeveloper } from '../../types/similarNewobjects';

export async function fetchNewobjectsBuilderIfNeeded(
  context: IApplicationContext,
  offersData: IOffersData,
  regionId: number,
): Promise<ISimilarNewobjectFromDeveloper[] | null> {
  const builders = offersData.newbuilding?.builders ?? [];
  const builderIds = builders.map((builder: { id: string }) => builder.id);

  if (offersData.offerCount > 0 && offersData.offerCount < 11 && builderIds.length > 0) {
    const newbuildingIdToSkip = offersData.newbuilding?.id;

    return fetchNewobjectsBuilder(context, { builderIds, regionId, newbuildingIdToSkip });
  }

  return null;
}
